import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Brand, BrandQueryParams } from "../types";
import { COMMON_STATUS } from "constants/constants";
import { languages } from "constants/constants";

interface BrandState {
	brands: Array<Brand>;
	brandsTotal: number;
	brand: Brand;
}

export const brandDefault: Brand = {
	name: "",
	image: "",
	status: COMMON_STATUS.enabled.value,
	translation: languages.reduce((newObj: any, el) => {
		newObj[el.key] = "";
		return newObj;
	}, {}),
};

const initialState: BrandState = {
	brands: [],
	brandsTotal: 0,
	brand: brandDefault,
};

export const brandSlice = createSlice({
	name: "brand",
	initialState,
	reducers: {
		setBrands: (state, action) => {
			state.brands = action.payload.data;
			state.brandsTotal = action.payload.total;
		},
		setBrand: (state, action) => {
			state.brand = action.payload;
		},
		changeStatusBrand: (state, action) => {
			const { id, status } = action.payload;
			const index = state.brands.findIndex(el => el.id === id);
			state.brands[index].status = status;
		},
	},
});

export const selectBrands = (state: RootState) => state.brand.brands;
export const selectBrandsTotal = (state: RootState) => state.brand.brandsTotal;
export const selectBrand = (state: RootState) => state.brand.brand;

export const { setBrands, setBrand, changeStatusBrand } = brandSlice.actions;

export interface GetBrandsAsyncPayload {
	query: Omit<BrandQueryParams, "skip" | "take"> & {
		skip?: number;
		take?: number;
	};
	callback?: () => void;
}
export interface GetBrandDetailsPayload {
	id: string;
}
export interface CreateBrandPayload {
	data: Brand;
	callback: () => void;
}
export interface UpdateBrandPayload {
	id: string;
	data: Brand;
	callback?: () => void;
}

export const getBrandsAsync = createAction(
	"brand/getBrands",
	(payload: GetBrandsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getBrandDetailsAsync = createAction(
	"brand/getBrandDetails",
	(payload: GetBrandDetailsPayload) => ({
		payload: payload,
	}),
);

export const createNewBrandAsync = createAction(
	"brand/createNewBrand",
	(payload: CreateBrandPayload) => ({
		payload: payload,
	}),
);

export const updateBrandAsync = createAction(
	"brand/updateBrand",
	(payload: UpdateBrandPayload) => ({
		payload: payload,
	}),
);

export default brandSlice.reducer;
